import createStyled from "../createStyled/index.js";
const styled = createStyled();
export default styled;